import { useQuery } from '@tanstack/react-query';

import { ZoneRule } from 'src/features/membershipType/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/memberships/membership-type/:membershipTypeId/zone-rules/:ruleId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    membershipTypeId: string;
    ruleId: string;
}
const queryFn = ({ membershipTypeId, ruleId, parkingId }: DTO): Promise<ZoneRule> => {
    return axios.get(formatResourcePath(RESOURCE, { membershipTypeId, ruleId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as MEMBERSHIP_TYPE_ZONE_RULE_RESOURCE, useQueryHook as useGetMembershipTypeZoneRule };
